var components
try {
  components = {
    uTabs: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-tabs/u-tabs" */ "uview-ui/components/u-tabs/u-tabs.vue"
      )
    },
    zPaging: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging/z-paging" */ "@/uni_modules/z-paging/components/z-paging/z-paging.vue"
      )
    },
    uImage: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-image/u-image" */ "uview-ui/components/u-image/u-image.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.squareList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = _vm.vk.pubfn.timeFormat(
      new Date(item._add_time),
      "yyyy-MM-dd hh:mm:ss"
    )
    var g1 = _vm.vk.pubfn.isNotNull(item.tumbup)
    var g2 = item.tumbups.length
    var g3 = item.comments.length
    var g4 = item.comments.length
    var l0 = item.comments.slice(0, 5)
    var g5 = item.comments.length
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
      g2: g2,
      g3: g3,
      g4: g4,
      l0: l0,
      g5: g5,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }